;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities.trend')
    .controller('csVulnTrendChartCtrl', csVulnTrendChartCtrl)

  function csVulnTrendChartCtrl($translate, VULNERABILITY_REPORT_TYPE) {
    'ngInject'

    var vm = this
    var model

    var emptyStateConfig = {
      new: {
        none: {
          translationKey:
            'variable_vulnerabilityTrendChartEmptyState_noDiscoveredOrNewlyRemediated',
          icon: 'info'
        },
        noDiscovered: {
          translationKey:
            'variable_vulnerabilityTrendChartEmptyState_noDiscovered',
          icon: 'check'
        },
        noRemediated: {
          translationKey:
            'variable_vulnerabilityTrendChartEmptyState_noNewlyRemediated',
          icon: 'warning'
        }
      },
      total: {
        noRemediated: {
          translationKey:
            'variable_vulnerabilityTrendChartEmptyState_noRemediated',
          icon: 'warning'
        }
      }
    }

    angular.extend(vm, {
      init: init,
      getEmptyStateMsg: getEmptyStateMsg,
      isMini: isMini
    })

    function init(type, viewData) {
      vm.model = {
        emptyStateIconKey: 'warning'
      }
      model = {
        type: type,
        viewData: viewData
      }
    }

    function getEmptyStateMsg() {
      if (!model) {
        return
      }

      var config = getEmptyStateConfig()
      if (config) {
        vm.model.emptyStateIconKey = config.icon
        return $translate.instant(config.translationKey, {
          lastNUnitsOfTime: $translate.instant(model.viewData.rangeLabel)
        })
      }
    }

    function getEmptyStateConfig() {
      var type = model.type,
        totalDiscovered = model.viewData.totalDiscovered,
        totalRemediated = model.viewData.totalRemediated
      if (type === VULNERABILITY_REPORT_TYPE.NEW) {
        if (!totalDiscovered && !totalRemediated) {
          return emptyStateConfig.new.none
        } else if (!totalDiscovered && totalRemediated) {
          return emptyStateConfig.new.noDiscovered
        } else if (totalDiscovered && !totalRemediated) {
          return emptyStateConfig.new.noRemediated
        }
      } else if (
        type === VULNERABILITY_REPORT_TYPE.TOTAL &&
        totalRemediated === 0
      ) {
        return emptyStateConfig.total.noRemediated
      }
    }

    function isMini() {
      if (!model) {
        return false
      }
      return model.viewData.isMini === true
    }
  }
})()
